import $ from "jquery";

$(() => {
  $(".policyConfirmationCheckbox-checkbox").on("click", function (this: any) {
    const checked = $(this).is(":checked");
    const submitButton = $('.login.roundBox input[type="submit"]');
    submitButton.prop("disabled", !checked);
  });
});
